var members_directory = (function ($) {

    var _init = function () {
        _init_filters_form();
    };

    var _init_filters_form = function() {
        var $filters_form = $('#members-directory-search-form');

        if ($filters_form.length > 0) {
            var $select = $filters_form.find('select');

            if ($select.length > 0) {
                $select.select2({
                    dropdownParent: $('body'),
                });
            }

            $filters_form.on('submit', function(e) {
                $(this).find(":input").filter(function () {
                    return !this.value;
                }).attr("disabled", true);
            });
        }
    }

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = members_directory;